import { createFileRoute } from '@tanstack/react-router';

import { StaffCapacityView } from 'src/sections/staff/capacity/capacity-view';

export const Route = createFileRoute('/w/capacity')({
  component: StaffCapacityPage,
});

function StaffCapacityPage() {
  return <StaffCapacityView />;
}
